import React, { useEffect, useState } from 'react';
import { fetchIncidents, createIncident, updateIncident } from '../../../../Utilities/api/index.js';

export default function AdminIncidentLog() {
  const [incidents, setIncidents] = useState([]);
  const [newIncident, setNewIncident] = useState({ title: '', description: '', status: 'Open' });
  const [loading, setLoading] = useState(false);

  // Load incidents on mount
  useEffect(() => {
    loadIncidents();
  }, []);

  const loadIncidents = async () => {
    setLoading(true);
    try {
      const data = await fetchIncidents();
      setIncidents(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateIncident = async () => {
    if (!newIncident.title || !newIncident.description) return alert('Please fill all fields');
    try {
      await createIncident(newIncident);
      setNewIncident({ title: '', description: '', status: 'Open' });
      loadIncidents();
    } catch (err) {
      console.error(err);
    }
  };

  const handleStatusChange = async (id, status) => {
    try {
      await updateIncident(id, { status });
      loadIncidents();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="incident-log-container">
      <h2>Incident Log</h2>

      {/* Add New Incident */}
      <div className="incident-form">
        <input
          type="text"
          placeholder="Title"
          value={newIncident.title}
          onChange={(e) => setNewIncident({ ...newIncident, title: e.target.value })}
        />
        <textarea
          placeholder="Description"
          value={newIncident.description}
          onChange={(e) => setNewIncident({ ...newIncident, description: e.target.value })}
        />
        <button onClick={handleCreateIncident}>Add Incident</button>
      </div>

      {/* Incident List */}
      {loading ? (
        <p>Loading incidents...</p>
      ) : (
        <ul className="incident-list">
          {incidents.map((incident) => (
            <li key={incident.id}>
              <strong>{incident.title}</strong> — {incident.status}
              <p>{incident.description}</p>
              <select
                value={incident.status}
                onChange={(e) => handleStatusChange(incident.id, e.target.value)}
              >
                <option value="Open">Open</option>
                <option value="In Progress">In Progress</option>
                <option value="Resolved">Resolved</option>
              </select>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
